module.exports = __webpack_public_path__ + "static/img/top04.80b6f660.svg";